module.exports = __webpack_public_path__ + "media/images/black_history_month/chef-image-600b4d59a5a8d346c1ef32eff89de861.svg";